// third-party
// assets
import {
	ControlFilled,
	DollarOutlined,
	ToolOutlined,
	ProfileOutlined,
	FormOutlined,
	BookOutlined,
	SlidersOutlined,
	RadarChartOutlined,
	DatabaseOutlined,
	BugOutlined,
	ReconciliationOutlined
} from '@ant-design/icons';

// type
import { NavItemType } from 'layout/mantis/types/MenuType';
import useAuthContext from 'context/useAuthContext';
import useGlobalContext from 'context/useGlobalContext';
import { useEffect } from 'react';

// icons
const icons = {
	controlFilled: ControlFilled,
	toolOutlined: ToolOutlined,
	profileOutlined: ProfileOutlined,
	formOutlined: FormOutlined,
	bookOutlined: BookOutlined,
	slidersOutlined: SlidersOutlined,
	radarChartOutlined: RadarChartOutlined,
	dollarOutlined: DollarOutlined,
	databaseOutlined: DatabaseOutlined,
	bugOutlined: BugOutlined,
	reconciliationOutlined: ReconciliationOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

export default function SettingMenuItems() {
	const { permissions, roles } = useAuthContext();
	const { activeCompany } = useGlobalContext();

	let items: NavItemType = {};

	if (permissions) {
		if (
			permissions.some((el: string) => {
				return el === 'Update_Setting' || el === 'Base_Setting' || el === 'Admin_Reports';
			})
		) {
			items = {
				id: 'group-setting',
				title: 'Settings',
				icon: icons.toolOutlined,
				type: 'group',
				children: []
			};

			if (
				permissions.some((el: string) => {
					return el === 'Update_Setting';
				})
			) {
				items.children.push({
					id: 'core-setting-general',
					title: 'General',
					type: 'item',
					url: '/app/settings/general',
					icon: icons.toolOutlined,
					breadcrumbs: true
				});
			}

			if (activeCompany.value == null) {
				if (
					permissions.some((el: string) => {
						return el === 'Update_Setting';
					})
				) {
					items.children.push({
						id: 'core-setting-backup',
						title: 'Database Backup',
						type: 'item',
						url: '/app/settings/backup',
						icon: icons.databaseOutlined,
						breadcrumbs: true
					});
				}
			}

			if (
				permissions.some((el: string) => {
					return el === 'Base_Setting';
				})
			) {
				items.children.push({
					id: 'core-setting-dynamic_buttons',
					title: 'Dynamic Buttons',
					type: 'item',
					url: '/app/settings/dynamic/buttons',
					icon: icons.controlFilled,
					breadcrumbs: true
				});
			}

			// if (roles == 'developer') {

			// }

			// if (activeCompany.value == null) {
			// 	// if (
			// 	// 	permissions.some((el: string) => {
			// 	// 		return el === 'Base_Setting';
			// 	// 	})
			// 	// ) {
			// 	// 	let hr_setting = {
			// 	// 		id: 'core-setting-hr',
			// 	// 		title: 'HR',
			// 	// 		type: 'collapse',
			// 	// 		icon: icons.controlFilled,
			// 	// 		breadcrumbs: true,
			// 	// 		children: []
			// 	// 	};
			// 	// 	hr_setting.children.push({
			// 	// 		id: 'core-setting-hr-departments',
			// 	// 		title: 'Departments',
			// 	// 		type: 'item',
			// 	// 		url: '/app/settings/hr/departments',
			// 	// 		breadcrumbs: true
			// 	// 	});
			// 	// 	hr_setting.children.push({
			// 	// 		id: 'core-setting-hr-job-titles',
			// 	// 		title: 'Job Titles',
			// 	// 		type: 'item',
			// 	// 		url: '/app/settings/hr/job/titles',
			// 	// 		breadcrumbs: true
			// 	// 	});
			// 	// 	hr_setting.children.push({
			// 	// 		id: 'core-setting-hr-branches',
			// 	// 		title: 'Branches',
			// 	// 		type: 'item',
			// 	// 		url: '/app/settings/hr/branches',
			// 	// 		breadcrumbs: true
			// 	// 	});
			// 	// 	items.children.push(hr_setting);
			// 	// }
			// 	// if (
			// 	// 	permissions.some((el: string) => {
			// 	// 		return el === 'Base_Setting';
			// 	// 	})
			// 	// ) {
			// 	// 	let finance_setting = {
			// 	// 		id: 'core-setting-finance',
			// 	// 		title: 'Finance',
			// 	// 		type: 'collapse',
			// 	// 		icon: icons.dollarOutlined,
			// 	// 		breadcrumbs: true,
			// 	// 		children: []
			// 	// 	};
			// 	// 	finance_setting.children.push({
			// 	// 		id: 'core-setting-finance-currencies',
			// 	// 		title: 'Currencies',
			// 	// 		type: 'item',
			// 	// 		url: '/app/settings/finance/currencies',
			// 	// 		breadcrumbs: true
			// 	// 	});
			// 	// 	finance_setting.children.push({
			// 	// 		id: 'core-setting-finance-payment-methods',
			// 	// 		title: 'Payment Methods',
			// 	// 		type: 'item',
			// 	// 		url: '/app/settings/finance/payment/methods',
			// 	// 		breadcrumbs: true
			// 	// 	});
			// 	// 	items.children.push(finance_setting);
			// 	// }
			// 	// if (permissions.some((el: string) => {
			// 	//     return (el === 'Base_Setting')
			// 	// })) {
			// 	//     let profile_setting = {
			// 	//         id: 'core-setting-profile',
			// 	//         title: 'Profile',
			// 	//         type: 'collapse',
			// 	//         icon: icons.profileOutlined,
			// 	//         breadcrumbs: true,
			// 	//         children: []
			// 	//     };
			// 	//     profile_setting.children.push({
			// 	//         id: 'core-setting-profile-certification-type',
			// 	//         title: 'Certification Type',
			// 	//         type: 'item',
			// 	//         url: '/app/settings/profile/certification/types',
			// 	//         breadcrumbs: true,
			// 	//     });
			// 	//     profile_setting.children.push({
			// 	//         id: 'core-setting-profile-education-type',
			// 	//         title: 'Education Type',
			// 	//         type: 'item',
			// 	//         url: '/app/settings/profile/education/types',
			// 	//         breadcrumbs: true,
			// 	//     });
			// 	//     profile_setting.children.push({
			// 	//         id: 'core-setting-profile-membership-type',
			// 	//         title: 'Membership Type',
			// 	//         type: 'item',
			// 	//         url: '/app/settings/profile/membership/types',
			// 	//         breadcrumbs: true,
			// 	//     });
			// 	//     profile_setting.children.push({
			// 	//         id: 'core-setting-profile-experience-type',
			// 	//         title: 'Experience Type',
			// 	//         type: 'item',
			// 	//         url: '/app/settings/profile/experience/types',
			// 	//         breadcrumbs: true,
			// 	//     });
			// 	//     profile_setting.children.push({
			// 	//         id: 'core-setting-profile-cpd-activity-type',
			// 	//         title: 'CPD Activity Type',
			// 	//         type: 'item',
			// 	//         url: '/app/settings/profile/activity/types',
			// 	//         breadcrumbs: true,
			// 	//     });
			// 	//     profile_setting.children.push({
			// 	//         id: 'core-setting-profile-cpd-year-targets',
			// 	//         title: 'CPD Year Targets',
			// 	//         type: 'item',
			// 	//         url: '/app/settings/profile/year/targets',
			// 	//         breadcrumbs: true,
			// 	//     });
			// 	//     items.children.push(profile_setting);
			// 	// }
			// 	// if (permissions.some((el: string) => {
			// 	//     return (el === 'Base_Setting')
			// 	// })) {
			// 	//     let exam_setting = {
			// 	//         id: 'core-setting-exam',
			// 	//         title: 'Exam',
			// 	//         type: 'collapse',
			// 	//         icon: icons.formOutlined,
			// 	//         breadcrumbs: true,
			// 	//         children: []
			// 	//     };
			// 	//     exam_setting.children.push({
			// 	//         id: 'core-setting-exam-answer-type',
			// 	//         title: 'Answer Type',
			// 	//         type: 'item',
			// 	//         url: '/app/settings/exam/answer/types',
			// 	//         breadcrumbs: true,
			// 	//     });
			// 	//     exam_setting.children.push({
			// 	//         id: 'core-setting-exam-question-type',
			// 	//         title: 'Question Type',
			// 	//         type: 'item',
			// 	//         url: '/app/settings/exam/question/types',
			// 	//         breadcrumbs: true,
			// 	//     });
			// 	//     exam_setting.children.push({
			// 	//         id: 'core-setting-exam-type',
			// 	//         title: 'Exam Type',
			// 	//         type: 'item',
			// 	//         url: '/app/settings/exam/types',
			// 	//         breadcrumbs: true,
			// 	//     });
			// 	//     items.children.push(exam_setting);
			// 	// }
			// 	// if (
			// 	// 	permissions.some((el: string) => {
			// 	// 		return el === 'Base_Setting';
			// 	// 	})
			// 	// ) {
			// 	// 	let course_setting = {
			// 	// 		id: 'core-setting-course',
			// 	// 		title: 'Course',
			// 	// 		type: 'collapse',
			// 	// 		icon: icons.bookOutlined,
			// 	// 		breadcrumbs: true,
			// 	// 		children: []
			// 	// 	};
			// 	// 	course_setting.children.push({
			// 	// 		id: 'core-setting-course-type',
			// 	// 		title: 'Course Type',
			// 	// 		type: 'item',
			// 	// 		url: '/app/settings/course/types',
			// 	// 		breadcrumbs: true
			// 	// 	});
			// 	// 	course_setting.children.push({
			// 	// 		id: 'core-setting-course-content-type',
			// 	// 		title: 'Content Type',
			// 	// 		type: 'item',
			// 	// 		url: '/app/settings/course/content/types',
			// 	// 		breadcrumbs: true
			// 	// 	});
			// 	// 	course_setting.children.push({
			// 	// 		id: 'core-setting-course-awarding-bodies',
			// 	// 		title: 'Awarding Bodies',
			// 	// 		type: 'item',
			// 	// 		url: '/app/settings/course/awarding/bodies',
			// 	// 		breadcrumbs: true
			// 	// 	});
			// 	// 	course_setting.children.push({
			// 	// 		id: 'core-setting-course-management-levels',
			// 	// 		title: 'Management Levels',
			// 	// 		type: 'item',
			// 	// 		url: '/app/settings/course/management/levels',
			// 	// 		breadcrumbs: true
			// 	// 	});
			// 	// 	course_setting.children.push({
			// 	// 		id: 'core-setting-course-delivery-options',
			// 	// 		title: 'Delivery Options',
			// 	// 		type: 'item',
			// 	// 		url: '/app/settings/course/delivery/options',
			// 	// 		breadcrumbs: true
			// 	// 	});
			// 	// 	course_setting.children.push({
			// 	// 		id: 'core-setting-course-delivery-patterns',
			// 	// 		title: 'Delivery Patterns',
			// 	// 		type: 'item',
			// 	// 		url: '/app/settings/course/delivery/patterns',
			// 	// 		breadcrumbs: true
			// 	// 	});
			// 	// 	items.children.push(course_setting);
			// 	// }
			// 	// if (
			// 	// 	permissions.some((el: string) => {
			// 	// 		return el === 'Base_Setting';
			// 	// 	})
			// 	// ) {
			// 	// 	let meeting_setting = {
			// 	// 		id: 'core-setting-meeting',
			// 	// 		title: 'Meeting',
			// 	// 		type: 'collapse',
			// 	// 		icon: icons.slidersOutlined,
			// 	// 		breadcrumbs: true,
			// 	// 		children: []
			// 	// 	};
			// 	// 	meeting_setting.children.push({
			// 	// 		id: 'core-setting-meeting-type',
			// 	// 		title: 'Meeting Type',
			// 	// 		type: 'item',
			// 	// 		url: '/app/settings/meeting/types',
			// 	// 		breadcrumbs: true
			// 	// 	});
			// 	// 	meeting_setting.children.push({
			// 	// 		id: 'core-setting-meeting-mode-of-communication',
			// 	// 		title: 'Modes of Communication',
			// 	// 		type: 'item',
			// 	// 		url: '/app/settings/mode/of/communication',
			// 	// 		breadcrumbs: true
			// 	// 	});
			// 	// 	meeting_setting.children.push({
			// 	// 		id: 'core-setting-meeting-frequency-of-meeting',
			// 	// 		title: 'Frequency of Meeting',
			// 	// 		type: 'item',
			// 	// 		url: '/app/settings/frequency/of/meeting',
			// 	// 		breadcrumbs: true
			// 	// 	});
			// 	// 	items.children.push(meeting_setting);
			// 	// }
			// 	// if (
			// 	// 	permissions.some((el: string) => {
			// 	// 		return el === 'Base_Setting';
			// 	// 	})
			// 	// ) {
			// 	// 	let core_setting = {
			// 	// 		id: 'core-setting-core',
			// 	// 		title: 'Core',
			// 	// 		type: 'collapse',
			// 	// 		icon: icons.radarChartOutlined,
			// 	// 		breadcrumbs: true,
			// 	// 		children: []
			// 	// 	};
			// 	// 	core_setting.children.push({
			// 	// 		id: 'core-setting-core-category',
			// 	// 		title: 'Categories',
			// 	// 		type: 'item',
			// 	// 		url: '/app/settings/core/categories',
			// 	// 		breadcrumbs: true
			// 	// 	});
			// 	// 	core_setting.children.push({
			// 	// 		id: 'core-setting-core-industry',
			// 	// 		title: 'Industries',
			// 	// 		type: 'item',
			// 	// 		url: '/app/settings/core/industries',
			// 	// 		breadcrumbs: true
			// 	// 	});
			// 	// 	items.children.push(core_setting);
			// 	// }
			// }
		}
	}

	return items;
}
